import api from "../api";

// Job Position CRUD
export const fetchJobPositions = async () => {
  const res = await api.get("/job-positions");
  return res.data?.positions || res.data;
};

export const addJobPosition = async (formData: FormData | object) => {
  return api.post("/job-positions", formData);
};

export const updateJobPosition = async (
  id: number | string,
  formData: FormData | object,
) => {
  return api.post(`/job-positions/${id}`, formData);
};

export const hideJobPosition = async (id: number | string) => {
  return api.post(`/job-positions/${id}/hide`);
};

export const unhideJobPosition = async (id: number | string) => {
  return api.post(`/job-positions/${id}/unhide`);
};

export const deleteJobPosition = async (id: number | string) => {
  return api.delete(`/job-positions/${id}`);
};

// Careers Page Config
export const fetchCareersPageConfig = async () => {
  const res = await api.get("/careers-page-config");
  return res.data?.config || res.data;
};

export const addCareersPageConfig = async (formData: FormData | object) => {
  return api.post("/careers-page-config", formData);
};

export const updateCareersPageConfig = async (
  id: number | string,
  formData: FormData | object,
) => {
  return api.post(`/careers-page-config/${id}`, formData);
};
